export default "__VITE_ASSET__CGwrLeHu__"